import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de création d'un plan d'abonnement entreprise
 * (`POST /SubscriptionPlans/add`, guide §6.5). Le prix mensuel est saisi
 * en unité MAJEURE ; conversion en `monthlyPriceMinor` (entier, unité
 * mineure) au submit via `majorToMinor`.
 *
 * Factory (règle projet) : créé via `createSubscriptionPlanSchema()` et
 * mémoïsé au niveau composant sur la langue courante — jamais d'instance
 * exportée.
 */
export const createSubscriptionPlanSchema = () =>
  z
    .object({
      code: z
        .string()
        .trim()
        .min(1, { message: t("requiredFieldError") })
        .max(64, { message: t("invalidFieldError") }),
      name: z
        .string()
        .trim()
        .min(1, { message: t("requiredFieldError") }),
      minEmployees: z
        .number({ invalid_type_error: t("invalidFieldError") })
        .int({ message: t("invalidFieldError") })
        .min(1, { message: t("invalidFieldError") }),
      maxEmployees: z
        .number({ invalid_type_error: t("invalidFieldError") })
        .int({ message: t("invalidFieldError") })
        .min(1, { message: t("invalidFieldError") }),
      /** Prix mensuel en unité MAJEURE (converti au submit). */
      monthlyPrice: z
        .number({ invalid_type_error: t("invalidFieldError") })
        .min(0, { message: t("invalidFieldError") }),
      currency: z
        .string()
        .trim()
        .regex(/^[A-Z]{3}$/, { message: t("invalidFieldError") }),
    })
    .superRefine((values, ctx) => {
      if (values.maxEmployees < values.minEmployees) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["maxEmployees"],
          message: t("invalidFieldError"),
        });
      }
    });

export type SubscriptionPlanFormValues = z.infer<
  ReturnType<typeof createSubscriptionPlanSchema>
>;
